var exports = {
  "kL": "xe564cbfb--9f5495--container",
  "AS": "xe564cbfb--9f5495--item",
  "is": "xe564cbfb--9f5495--is-subtitle",
  "Kk": "xe564cbfb--9f5495--icon",
  "qd": "xe564cbfb--9f5495--icon--hidden",
};

module.exports = exports;
